import {
  MULTICURRENCY_RECHARGE,
  MULTICURRENCY_SETUP3DS,
  MULTICURRENCY_CHECK_ENROLLMENT
} from "../apis/payment";

export default {
  data() {
    return {};
  },
  methods: {
    cyberSourceInfo(card) {
      const paymentInfo = {};
      // 获取用户信息，使用传入的参数或默认值
      const _user = this.user || {};
      const isIOS = this.system === "ios";
      const payUserInfo = {
        address1: "",
        locality: "",
        postalCode: "",
        lastName: _user.lastName || "",
        firstName: _user.firstName || "",
        email: _user.email || "",
        phoneNumber: _user.pmobile || "",
        country: process.env.VUE_APP_COUNTRY || "US",
        administrativeArea: process.env.VUE_APP_CURRENCY || "USD"
      };
      console.log("🚀 ~ payUserInfo:", payUserInfo);
      paymentInfo["payUserInfo"] = btoa(JSON.stringify(payUserInfo));
      var cardInfo = {
        cvv: card["cvv"] || "",
        expirationYear: card["expiryYear"] || "",
        expirationMonth: card["expiryMonth"] || "",
        cardNumber: card["cardNumber"],
        httpBrowserLanguage: this.locale.value || "en-US",
        userAgentBrowserValue: isIOS
          ? "Mozilla/5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1"
          : "Mozilla/5.0 (Linux; Android 8.0.0; Pixel 2 XL Build/OPD1.170816.004) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.138 Mobile Safari/537.36",
        httpAcceptContent: "text/html,application/xhtml+xml"
      };
      console.log("🚀 ~ cardInfo:", cardInfo);
      paymentInfo["cardInfo"] = btoa(JSON.stringify(cardInfo));
      return paymentInfo;
    },
    // 支付租借
    async onCyberSourcePayment(query, callback) {
      const { CyberPayInfo } = this.$store.state;
      const payInfo = CyberPayInfo[query.TransactionId];
      if (!payInfo || !payInfo.paymentId) return;
      payInfo.threeDSAuthenticationTransactionId = query.TransactionId;
      const headers = {
        headers: { "Content-Type": "application/json;charset=UTF-8" }
      };
      const { data = {} } = await this.$Request(
        "POST",
        MULTICURRENCY_RECHARGE,
        payInfo,
        headers
      );
      if (data && data.outTradeNo) {
        const res = await this.MulticurrencyConfirm(data.outTradeNo);
        this.$store.commit("CyberPayInfo", {});
        callback && callback(res);
      }
    },
    async onCyberSourcePay(param, callback) {
      const query = {
        ...param,
        paymentId: this.pId,
        amount: this.price || "",
        userOpenId: this.user.p_openID,
        qrCode: this.qrcode || this.$route.query.cabinetID || ""
      };
      this.$loading(true);
      const setup3DS = await this.multicurrencySetup3DS(query, callback);
      if (setup3DS && setup3DS["consumerAuthenticationInformation"]) {
        this.$loading(false);
        var Information = setup3DS["consumerAuthenticationInformation"];
        Information.htmlType = "formHiddenHtml";
        const { CyberPayInfo = {} } = this.$store.state;
        const referenceId = Information["referenceId"];
        CyberPayInfo[referenceId] = { ...query, ...Information };
        CyberPayInfo[`${referenceId}_recharge`] = param;
        this.$store.commit("CyberPayInfo", CyberPayInfo);
        this.onLoadHandleHtml(Information);
      } else if (setup3DS["errorInformation"]) {
        this.$loading(false);
        this.$toast(setup3DS["errorInformation"]["message"]);
      }
    },
    //   3DS设置
    async multicurrencySetup3DS(param, callback) {
      try {
        const query = {
          paymentId: param.paymentId,
          qrCode: param.qrCode || "",
          rechargeType: param.rechargeType,
          cardInfo: param.cardInfo
        };
        const headers = {
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        };
        const { data = {} } = await this.$Request(
          "POST",
          MULTICURRENCY_SETUP3DS,
          query,
          headers
        );
        return data["paymentInfo"] || {};
      } catch (error) {
        console.log("🚀 ~ error:", error);
        this.$loading(false);
        this.$toast(error);
      }
    },
    //   检查注册状态
    async multicurrencyCheckEnrollment(param) {
      try {
        const query = {
          paymentId: param.paymentId,
          amount: param.amount || "",
          qrCode: param.qrCode || "",
          rechargeType: param.rechargeType,
          cardInfo: param.cardInfo,
          payUserInfo: param.payUserInfo,
          threeDSAuthenticationSessionId: param.referenceId
        };
        const headers = {
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        };
        this.$loading(true);
        const { data = {} } = await this.$Request(
          "POST",
          MULTICURRENCY_CHECK_ENROLLMENT,
          query,
          headers
        );
        if (data && data["paymentInfo"]) {
          this.$loading(false);
          const paymentInfo = data["paymentInfo"] || {};
          if (paymentInfo["status"] === "PENDING_AUTHENTICATION") {
            var Information =
              paymentInfo["consumerAuthenticationInformation"] ?? {};
            Information.htmlType = "formVisibleHtml";
            const { CyberPayInfo = {} } = this.$store.state;
            CyberPayInfo[Information["authenticationTransactionId"]] =
              CyberPayInfo[`${param.referenceId}_recharge`];
            this.$store.commit("CyberPayInfo", CyberPayInfo);
            console.log("🚀 ~ Information:", Information, this.$store);
            this.onLoadHandleHtml(Information);
          }
        }
      } catch (error) {
        console.log("🚀 ~ error:", error);
        this.$loading(false);
        this.$toast(error);
      }
    },
    onLoadHandleHtml(Result = {}) {
      try {
        if (!Result.accessToken) return;
        // 跳转到 cyberPay 页面
        const _query = {
          type: Result.htmlType,
          accessToken: Result.accessToken
          //   collectionUrl: param.collectionUrl
        };
        if (Result.htmlType === "formHiddenHtml") {
          _query.referenceId = Result.referenceId;
          _query.collectionUrl = Result.deviceDataCollectionUrl;
        } else if (Result.htmlType === "formVisibleHtml") {
          _query.collectionUrl = Result.stepUpUrl;
        }
        this.$router.push({ path: "/payment/cyberPay", query: _query });
      } catch (err) {
        console.error("onLoadHiddenHtml Error:", err);
      }
    }
  }
};
